import React, { Component } from "react"
import { connect } from 'react-redux'

import ResidencesContainer from './shared/ResidencesContainer'
import { PootsyButton } from './DesignFunctions'
import PropTypes from 'prop-types'
import * as residencesActions from '../actions/acResidences'
import ModalLayout from "./shared/ModalLayout"

class AccountAddresses extends Component {


	state = {
		deleteConfirmation: false,
		mode: 'create'
	}

	componentWillMount = () => {
		this.props.dispatch(residencesActions.fetchResidences())
	}


	render() {

		let { t } = this.context

		return (
			<div className="AccountAddresses">
				{this.state.deleteConfirmation && this.renderDeleteConfirmationModal()}
				<ResidencesContainer
					residences={this.props.residences}
					onEditResidence={this.onEditResidence}
					onDeleteResidence={this.onDeleteResidence}
				/>
				<div className="divider"/>
				<PootsyButton text={t('save')}
							  onClick={this.onSaveResidenceButtonClick}
							  disabled={!this.isNextButtonEnabled()}
				/>
			</div>
		)
	}

	onSaveResidenceButtonClick = () => {
		if (this.state.mode === 'create') {
			this.props.dispatch(residencesActions.createResidence())
		}
		else if (this.state.mode === 'update') {
			this.props.dispatch(residencesActions.updateResidence())
		}
		this.setState({ mode: 'create' })
	}

	onEditResidence = (residence) => {

		if (this.state.mode === 'update') {
			this.setState({ mode: 'create' })
			this.props.dispatch(residencesActions.clearNewResidence())
		}
		else {
			this.setState({ mode: 'update' })

			let updatingResidence = {
				hasPets: residence.hasPets,
				surface: residence.surface,
				type: residence.type,
				streetName: residence.address.streetName,
				streetNumber: residence.address.streetNumber,
				zipCode: residence.address.zipCode,
				howToGetIn: residence.howToGetIn,
				otherInfo: residence.otherInfo,
				city: residence.address.city,
				id: residence.id
			}
			this.props.dispatch(residencesActions.updateNewResidence(updatingResidence))
		}
	}

	onDeleteResidence = (residence) => {
		this.setState({ deleteConfirmation: true })
		this.props.dispatch(residencesActions.selectResidenceForAction(residence.id))
	}

	onDeleteResidenceConfirmed = () => {
		this.props.dispatch(residencesActions.deleteResidence())
		this.toggleModal()
	}

	renderDeleteConfirmationModal = () => {
		let { t } = this.context
		return (
			<ModalLayout
				customClass="DeleteConfirmationModal"
				contentClass="delete-confirmation-modal-content"
				title={t('delete_residence_title')}
				closeModal={this.toggleModal}
				buttons={[
					<PootsyButton text={t("continue")} onClick={this.onDeleteResidenceConfirmed} key={0}/>,
					<PootsyButton text={t("cancel")} theme="cancel" onClick={this.toggleModal} key={1}/>
				]}
			>
			</ModalLayout>
		)
	}

	toggleModal = () => {
		this.setState({ deleteConfirmation: !this.state.deleteConfirmation })
	}

	isNextButtonEnabled = () => {
		return this.props.newResidence.streetName && this.props.newResidence.streetNumber && this.props.newResidence.zipCode && this.props.newResidence.city && this.props.newResidence.surface
	}

}

AccountAddresses.contextTypes = { t: PropTypes.func }
const mapStateToProps = state => ({
	residences: state.dataReducer.residences.residences,
	newResidence: state.dataReducer.residences.newResidence
})
export default connect(mapStateToProps)(AccountAddresses);


// WEBPACK FOOTER //
// ./src/components/AccountAddresses.js